import { Box, ModalHeader, Typo } from '@wrisk/ui-components'
import React, { FunctionComponent, useCallback } from 'react'
import { useNavigate } from 'react-router'

import {
  TKey,
  useWriskTranslation,
} from '../../../../../../infrastructure/internationalisation'
import { AppPath } from '../../../../../AppPath'
import { ActionBar } from '../../../../../organisms/form'

const tKey = TKey('components.outstanding-balance-modal')

export const OutstandingBalanceModal: FunctionComponent = () => {
  const navigate = useNavigate()

  const { t } = useWriskTranslation()

  const onViewDashboardCallback = useCallback(() => navigate(AppPath.HOME), [navigate])

  return (
    <Box>
      <ModalHeader header={t(tKey('header'))} />
      <Typo>{t(tKey('content'))}</Typo>
      <ActionBar loading={false} onConfirm={onViewDashboardCallback} tKey={tKey} mt={6} />
    </Box>
  )
}
